<script lang="ts" setup>
import {useCartStore} from "@/stores/cart";
import {computed} from "vue";

const cartStore = useCartStore()

const props = withDefaults(defineProps<{ favorites?: boolean }>(), {
  favorites: false
})

const count = computed(() => {
  if (props.favorites) {
    return cartStore.favoritesCount
  }

  return cartStore.getItemsCount
})
</script>

<template>
  <div v-if="count" class="rounded-full size-4 text-white flex bg-[hsl(var(--roke-text-blue))]">
    <span class="m-auto leading-none text-[12px]">{{ count }}</span>
  </div>
</template>